module.exports = __webpack_public_path__ + "img/e_3_2_g.01ca592e.png";